import { ReactComponent as CodeSquare01Icon } from "components/Icons/code-square-01.svg";
import { ReactComponent as ReferralsIcon } from "components/Icons/referralsIcon.svg";
import { ReactComponent as ShoppingCart01Icon } from "components/Icons/shopping-cart-01.svg";
import { useMessage } from "hooks/intl";
import {
  AchievementRuleTypes,
  AchievementTriggers,
  AchievementTriggersUnion,
  BEAchievementRule,
} from "types/achievements";
import { TriggerBadge } from "../TriggerBadge";

export function TemplateBadge({ rules }: { rules: BEAchievementRule[] }) {
  const { message } = useMessage();
  const { CUSTOM_EVENT, TRANSACTION } = AchievementTriggers;

  const getLabelByTrigger = (trigger: AchievementTriggersUnion) => {
    switch (trigger) {
      case CUSTOM_EVENT:
        return "customEvents";
      case TRANSACTION:
        return "transactions";
      default:
        return "";
    }
  };

  const getIconByTrigger = (trigger: AchievementTriggersUnion) => {
    switch (trigger) {
      case CUSTOM_EVENT:
        return CodeSquare01Icon;
      case TRANSACTION:
        return ShoppingCart01Icon;
      default:
        return undefined;
    }
  };

  return rules.map((rule) =>
    rule.type === AchievementRuleTypes.REFERRAL ? (
      <TriggerBadge Icon={ReferralsIcon} label={message({ id: "referrals" })} />
    ) : (
      <TriggerBadge
        Icon={getIconByTrigger(rule.trigger)}
        label={message({ id: getLabelByTrigger(rule.trigger) })}
      />
    ),
  );
}
